import { types } from "../types/types";

const initialState = {
  setTabId: {},
};

export const tabsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.setTabId:
      return {
        ...state,
        setTabId: {
          ...action.payload,
        },
      };
    case types.authLogout:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};
